<template>
    <v-dialog v-model="selfVisible">
        <v-card dark>
            <v-list light class="dialog-list">
                <template v-for="item in types">
                    <v-list-tile
                        @click="select(item)"
                        v-if="item.type !== active"
                        :key="item.type"
                    >
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{ item.label }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "QDialog",
    data() {
        return {
            selfVisible: false
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        active: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters(["lang", "settedSecurities"]),
        types() {
            return this.settedSecurities
                .filter(v => v.type !== this.active)
                .map(item => {
                    return Object.assign({}, item, {
                        label: this.getLabel(item.type)
                    });
                });
        }
    },
    watch: {
        visible: {
            handler(val) {
                this.selfVisible = val;
            },
            immediate: true
        },
        selfVisible(val) {
            if (!val) {
                this.$emit("update:visible", false);
            }
        }
    },
    methods: {
        getLabel(type) {
            let tmp;
            switch (type) {
                case "mobile":
                    tmp = this.lang.security_phone_label;
                    break;
                case "email":
                    tmp = this.lang.security_email_label;
                    break;
                case "question":
                    tmp = this.lang.security_question_label;
                    break;
            }
            return tmp;
        },
        select(item) {
            this.$router.push({
                name: item.type,
                query: this.$route.query
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.dialog-list {
    max-height: 50vh;
    overflow: auto;
}
</style>
